export const feedbackHeroTokens = {
  fonts: {
    body: 'var(--fh-font-body, "Manrope", "Segoe UI", sans-serif)',
    display: 'var(--fh-font-display, "Space Grotesk", "Segoe UI", sans-serif)',
  },
  colors: {
    pageBg: '#F6F4F1',
    surface: '#FFFFFF',
    surfaceAlt: '#FCFBF8',
    border: 'rgba(15, 23, 42, 0.10)',
    softBorder: 'rgba(15, 23, 42, 0.06)',
    text: '#1F2937',
    subtext: '#6B7280',
    pos: { bg: '#EAF7EE', fg: '#1F5C3A', accent: '#2E8B57', chip: '#DFF1E6' },
    neu: { bg: '#FFF4E4', fg: '#7B4B0C', accent: '#D7A64A', chip: '#FBE8C8' },
    neg: { bg: '#FCEAE7', fg: '#7A2F2A', accent: '#D46D63', chip: '#F7D8D2' },
  },
};

export const getSentimentTone = (nota) => {
  const value = Number(nota || 0);
  if (!value || Number.isNaN(value)) {
    return {
      key: 'neu',
      label: 'Sem nota',
      ...feedbackHeroTokens.colors.neu,
    };
  }
  if (value >= 4) {
    return {
      key: 'pos',
      label: 'Positivo',
      ...feedbackHeroTokens.colors.pos,
    };
  }
  if (value === 3) {
    return {
      key: 'neu',
      label: 'Neutro',
      ...feedbackHeroTokens.colors.neu,
    };
  }
  return {
    key: 'neg',
    label: 'Negativo',
    ...feedbackHeroTokens.colors.neg,
  };
};

export const getSentimentKey = (nota) => getSentimentTone(nota).key;
